<template>
    <div>
        <page-title>版本发布</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/version/edit">发布新版本</router-link>
                    </div>
                    <div flex>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="app_id"
                                       clearable size="mini"
                                       placeholder="应用" @change="search()">
                                <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="version" label="版本号"></el-table-column>
                <el-table-column prop="app.display_name" label="应用"></el-table-column>
                <el-table-column label="文件">
                    <template slot-scope="scope">
                        <div>代码包：<a>{{scope.row.src_file}}</a></div>
                        <div>数据库：<a>{{scope.row.db_file}}</a></div>
                    </template>
                </el-table-column>
                <el-table-column label="时间">
                    <template slot-scope="scope">
                        <div>创建：{{scope.row.add_time}}</div>
                        <div>更新：{{scope.row.update_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <router-link :to="'/dashboard/admin/version/edit?id=' + scope.row.id">编辑</router-link>
                        <span class="text-split">|</span>
                        <el-button v-if="scope.row.is_delete === 0" type="text" @click="deleteItem(scope.row)">删除
                        </el-button>
                        <el-button v-else type="text" @click="recoveryItem(scope.row)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width:767px){
        .cell div a{
            display: inline-block;
            height: 4rem;
            overflow: hidden;
            text-overflow:ellipsis;
        }
    }
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    data() {
        return {
            app_id: null,
            loading: false,
            list: null,
            pagination: null,
            keyword: '',
            apps: []
        }
    },
    created() {
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/version/index',
                    params: {
                        app_id: this.app_id,
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteItem(item) {
            new Promise(resolve => {
                this.$confirm('确认删除该内容?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = 1
                this.loading = true
                axios({
                    url: 'admin/version/edit',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        item.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryItem(item) {
            const data = helper.clone(item)
            data.is_delete = 0
            this.loading = true
            axios({
                url: 'admin/version/edit',
                method: 'post',
                data: data
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    item.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        searchApps() {
            axios({
                url: 'admin/app/index'
            }).then(e => {
                if (e.data.code === 0) {
                    this.apps = e.data.data.list
                } else {
                    this.apps = []
                }
            }).catch(e => {
                this.apps = []
            })
        }
    }
}
</script>
